/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect, useMemo } from 'react'
import { PlusCircleIcon, SwitchHorizontalIcon } from '@heroicons/react/solid'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { setProductType } from 'store/slices/shopSlice'
import { useAppDispatch } from 'store/hooks'

import { MemoizedDomains } from 'containers/shop/domains/domains'
import WebHosting from 'containers/shop/webHosting/webHosting'
import Register from 'containers/shop/domains/register'
import Transfer from 'containers/shop/domains/transfer'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    name: string
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Products({ name }: Props) {
    const dispatch = useAppDispatch()
    const tabs = useMemo(() => ([
        {
            label: 'Register',
            icon: PlusCircleIcon,
            render: <Register/>
        },
        {
            label: 'Transfer',
            icon: SwitchHorizontalIcon,
            render: <Transfer/>
        }
    ]), [])

    useEffect(() => {
        dispatch(setProductType(name))
    }, [dispatch, name])

    switch (name) {
        case 'web-hosting':
            return <WebHosting/>
        case 'domains':
        default:
            return <MemoizedDomains tabs={tabs}/>
    }
}
